<script setup lang="ts">
import type { LibraryEntry } from '../../lib/library-entries'
import type { ShelfItem } from '../../lib/shelf-items'
import type { CollectionCell } from '../../lib/collection-presentation'
import ComicListRow from './comic-list-row.vue'
import CollectionListRow from './collection-list-row.vue'

/** 列表：作品一列、集合一列，事件的分法與書架相同。 */
defineProps<{ items: ShelfItem[] }>()
defineEmits<{
  info: [entry: LibraryEntry]; edit: [entry: LibraryEntry]; read: [entry: LibraryEntry]; backup: [entry: LibraryEntry]; relink: [entry: LibraryEntry]; remove: [entry: LibraryEntry]
  openCollection: [cell: CollectionCell]; readCollection: [cell: CollectionCell]; editCollection: [cell: CollectionCell]; dissolveCollection: [cell: CollectionCell]; deleteCollection: [cell: CollectionCell]
}>()
</script>

<template>
  <ul class="comic-list">
    <template v-for="item in items" :key="item.id">
      <ComicListRow v-if="item.kind === 'comic'" :entry="item.entry" @info="$emit('info', $event)" @edit="$emit('edit', $event)" @read="$emit('read', $event)" @backup="$emit('backup', $event)" @relink="$emit('relink', $event)" @remove="$emit('remove', $event)" />
      <CollectionListRow v-else :item="item" @open="$emit('openCollection', $event)" @read="$emit('readCollection', $event)" @edit="$emit('editCollection', $event)" @dissolve="$emit('dissolveCollection', $event)" @delete="$emit('deleteCollection', $event)" />
    </template>
  </ul>
</template>
